import React from "react";
import FACULTY_BADGE from "../images/FACULTY_BADGE.png";
import DELEGATE_BADGE from "../images/DELEGATE_BADGE.png";
import ORG_SEC_BADGE from "../images/ORG_SEC_BADGE.png";
import ASST_ORG_SEC_BADGE from "../images/ASST_ORG_SEC_BADGE.png";
import PRESIDENT_BADGE from "../images/PRESIDENT_BADGE.png";
import PAST_PRESIDENT_BADGE from "../images/PAST_PRESIDENT_BADGE.png";
import PRESIDENT_ELECT_BADGE from "../images/PRESIDENT_ELECT_BADGE.png";
import VP_BADGE from "../images/VP_BADGE.png";
import SECY_BADGE from "../images/SECY_BADGE.png";
import TREAS_BADGE from "../images/TREAS_BADGE.png";
import JT_TREAS_BADGE from "../images/JT_TREAS_BADGE.png";
import SCI_COMM_BADGE from "../images/SCI_COMM_BADGE.png";
import MEMBER_EC_BADGE from "../images/MEMBER_EC_BADGE.png";
import IMM_PAST_PRES_BADGE from "../images/IMM_PAST_PRES_BADGE.png";
import IMM_PAST_SEC_BADGE from "../images/IMM_PAST_SEC_BADGE.png";
import TRADE_BADGE from "../images/TRADE_BADGE.png";
import SUPPORT_BADGE from "../images/SUPPORT_BADGE.png";

import OSWB_LOGO from "../images/OSWB_LOGO.jpeg";
import { QRCode } from "antd";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import _ from "lodash";

class PublicBadge extends React.Component {
  state = {};
  componentDidMount() {
    const delegateId = this.props.match.params.delegateId;
    const delegateName = this.props.match.params.delegateName;
    const badgeSpec = this.props.match.params.badgeSpec;
    let badgeColour = "#006600";
    if (badgeSpec === "DELEGATE_BADGE") {
      badgeColour = "#990033";
    } else if (badgeSpec === "FACULTY_BADGE") {
      badgeColour = "#cc6600";
    }
    this.setState({
      delegateId: delegateId,
      delegateName: delegateName,
      badgeSpec: `/${badgeSpec}.png`,
      badgeColour: badgeColour,
    });
  }
  renderName = () => {
    let fontSize = "xxx-large";
    /*  if (_.max(_.split(this.state.delegateName, " ").map((x) => x.length)) > 9) {
      fontSize = "xx-large";
    } */
    let nameSplits = _.split(this.state.delegateName, " ").map((x) =>
      _.startCase(_.lowerCase(x))
    );

    // if any element of nameSplit is "Dr" or "Dr.", remove that
    nameSplits = nameSplits.filter((x) => x !== "Dr" && x !== "Dr.");

    return (
      <div
        style={{
          width: "5in",
          height: "6.5in",
          backgroundImage: `url(${this.state.badgeSpec})`,
          backgroundSize: "cover",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
        }}
      >
        <div style={{ width: "5in", height: "2.5in" }}></div>
        <div style={{ display: "flex" }}>
          <div style={{ width: "1.2in" }}></div>
          <div
            style={{
              width: "3.8in",
              height: "3.2in",
              fontSize: `${fontSize}`,
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              fontFamily: "Exo",
              fontWeight: "bold",
              color: `${this.state.badgeColour}`,
            }}
          >
            {nameSplits.map((each) => {
              return (
                <>
                  {each}
                  <br />
                </>
              );
            })}
          </div>
        </div>

        <div
          style={{
            backgroundColor: "white",
          }}
        >
          <QRCode
            level="H"
            color={`${this.state.badgeColour}`}
            value={`https://conference2023.oswb.org/c/${this.state.delegateId}`}
            size="120"
          />
        </div>
      </div>
    );
  };
  renderQR = () => {
    return (
      <div
        style={{
          width: "5in",
          height: "6.5in",
          backgroundImage: `url(${FACULTY_BADGE})`,
          backgroundSize: "cover",
        }}
      >
        <div
          style={{
            paddingTop: "2.5in",
            paddingLeft: "1.2in",
            width: "3.6in",
            height: "2.5in",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignContent: "center",
            fontFamily: "Exo",
            fontWeight: "bold",
          }}
        >
          <QRCode
            level="H"
            value={`https://www.google.com`}
            size="240"
            iconSize="60"
            icon={`${OSWB_LOGO}`}
          />
        </div>
      </div>
    );
  };
  render() {
    return <div className="print__badge">{this.renderName()}</div>;
  }
}

export default withRouter(PublicBadge);
